/**
 * 「実行前に無かった案件」を勤務 (shift_truck) ごとに返す。V3Plans の addedOrderIds
 * (PlanningsDelivery.presenter.tsx の currentOrderIds − beforeOrderIds) と同じ計算。
 *
 * Why not 減った案件も返す: ハイライトは「新しく割り付いた」ことを示すもので、
 * 外れた案件はその行から消えているため示す先が無い。
 */
export function diffNewlyAssigned(
  before: ReadonlyMap<number, ReadonlySet<number>> | null,
  after: ReadonlyMap<number, ReadonlySet<number>>,
): Map<number, Set<number>> {
  // スナップショットが無い = まだ配車を実行していない。全件を新規にすると
  // 画面を開いただけで全部が光る
  if (before === null) return new Map();

  const added = new Map<number, Set<number>>();

  after.forEach((orderIds, shiftTruckId) => {
    const previous = before.get(shiftTruckId);
    const diff = new Set<number>();
    orderIds.forEach((orderId) => {
      if (!previous?.has(orderId)) diff.add(orderId);
    });
    if (diff.size > 0) added.set(shiftTruckId, diff);
  });

  return added;
}
